import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Copy from 'Src/components/Copy';
import useRoute from 'Src/routes/useRoute';

import ClaimTerminal from './ClaimTerminal';
import { OrganizationAndLocationSelector } from './OrganizationAndLocationSelector';
import ProgressStepper from './ProgressStepper';
import { ProvisionLogin } from './ProvisionLogin';
import { ProvisionPage } from './ProvisionPage';
import { StepperFooter } from './StepperFooter';
import TerminalSelect from './TerminalSelect';
import { EmailWorkFlowStoreProvider, Step, useEmailWorkflow } from './useEmailWorkflow';


const EmailWorkflow: FC = () => {
  const { t } = useTranslation();
  const { navigate, crumbs } = useRoute();
  const workflow = useEmailWorkflow();

  return (
    <ProvisionPage
      header={<Copy variant="h6" value={t('labels.getStarted')}/>}
      content={{
        header: (
          <ProgressStepper activeStep={workflow.steps.current} steps={Object.values(workflow.steps.labels)}/>
        ),
        main: ((() => {
          switch (workflow.steps.current) {
            case Step.Login:
              return <ProvisionLogin />;
            case Step.LocationSelect:
              return <OrganizationAndLocationSelector />;
            case Step.TerminalSelect:
              return <TerminalSelect />;
            case Step.Review:
              return (
                <ClaimTerminal
                  location={workflow.data.current.location}
                  terminal={workflow.data.current.terminal}
                  domEventName="emailWorkflow.onGoNext"
                />
              );
            default:
              return null;
          }
        })()),
        footer: (
          <StepperFooter
            canGoPrev={workflow.steps.isFirst || workflow.steps.canGoPrev}
            canGoNext={workflow.steps.canGoNext}
            onPrevRequested={() => {
              if (workflow.steps.isFirst) {
                navigate(crumbs.provision.main.path);
              } else {
                workflow.steps.goPrev();
              }
            }}
            onNextRequested={() => workflow.steps.goNext()}
            nextLabel={workflow.steps.isFinal ? t('labels.claim') : undefined}
            prevLoading={workflow.steps.prevLoading}
            nextLoading={workflow.steps.nextLoading}
          />
        ),
      }}
    />
  );
};

// eslint-disable-next-line react/no-multi-comp
const EmailWorkflowWithProvider: FC = () => (
  <EmailWorkFlowStoreProvider>
    <EmailWorkflow />
  </EmailWorkFlowStoreProvider>
);

export default EmailWorkflowWithProvider;
